export const SECTIONS_COUNT = 6;
